import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AddToShoppingListSliceState {
  showToast: boolean;
  toastMessage: string;
  toastType: "success" | "error" | "remove";
  // For undo functionality when removing items
  removedMpIds: number[];
  removedItems: ShoppingListItem[];
}

export type ShowListToastPayload =
  | string
  | {
      message: string;
      type: "success" | "error";
    }
  | {
      message: string;
      type: "remove";
      removedMpIds: number[];
      removedItems: ShoppingListItem[];
    };

const initialState: AddToShoppingListSliceState = {
  showToast: false,
  toastMessage: "",
  toastType: "success",
  removedMpIds: [],
  removedItems: [],
};

export const addToShoppingListSlice = createSlice({
  name: "addToShoppingListSlice",
  initialState,
  reducers: {
    showListToast: (state, action: PayloadAction<ShowListToastPayload>) => {
      state.showToast = true;
      if (typeof action.payload === "string") {
        state.toastMessage = action.payload;
        state.toastType = "success";
        state.removedMpIds = [];
        state.removedItems = [];
      } else if (action.payload.type === "remove") {
        state.toastMessage = action.payload.message;
        state.toastType = "remove";
        state.removedMpIds = action.payload.removedMpIds;
        state.removedItems = action.payload.removedItems;
      } else {
        state.toastMessage = action.payload.message;
        state.toastType = action.payload.type;
        state.removedMpIds = [];
        state.removedItems = [];
      }
      return state;
    },
    hideListToast: (state) => {
      state.showToast = false;
      state.toastMessage = "";
      state.toastType = "success";
      state.removedMpIds = [];
      state.removedItems = [];

      return state;
    },
    clearRemovedItems: (state) => {
      state.removedMpIds = [];
      state.removedItems = [];
      return state;
    },
  },
});

export const { showListToast, hideListToast, clearRemovedItems } = addToShoppingListSlice.actions;
export default addToShoppingListSlice;
